export const SLACK_LINK_TOKEN_KEY = 'ros.slackLinkToken'

/**
 * Move the one-time Slack token out of the URL before analytics/providers mount.
 * The gateway places it in the fragment so it is never sent in an HTTP request.
 */
export function captureSlackLinkToken(location: Location = window.location): void {
  if (location.pathname !== '/slack/connect') return
  const fragment = new URLSearchParams(location.hash.replace(/^#/, ''))
  const token = fragment.get('token')
  if (!token) return
  try { sessionStorage.setItem(SLACK_LINK_TOKEN_KEY, token) } catch { /* page will show an expired-link state */ }

  const clean = new URL(location.href)
  clean.hash = ''
  window.history.replaceState({}, '', clean.pathname + clean.search + clean.hash)
}
